import React, {Component} from 'react';
import {Link} from 'react-router';
import Api from '../../Api';
import classnames from 'classnames';
import Cart from '../Cart';
import TopSearch from '../TopSearch';

import UserHeader from './user';

import './style.less';
import Logo from '../../images/logo.svg';

const availableRoutes = [
  '/admin',
  '/retailer',
  '/checkout',
  '/user',
  '/login',
  '/logout',
  '/apply',
  '/brand-suggestion'
];

function hasLocationChanged(oldLocation, newLocation) {
  return (oldLocation && !newLocation) || (!oldLocation && newLocation) || (oldLocation && newLocation && oldLocation.pathname !== newLocation.pathname);
}

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.floatingHeader = this.floatingHeader.bind(this);
    this.logoLink = this.logoLink.bind(this);

    this.state = {
      user: props.user,
      toastProductToken: null,
      inMarketplace: this.inMarketplace(props.location)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (hasLocationChanged(nextProps.location, this.props.location)) {
      this.setState({
        inMarketplace: this.inMarketplace(nextProps.location)
      });
    }

    if (nextProps.user !== this.state.user) {
      this.setState({
        user: nextProps.user
      });
    }
  }

  componentWillMount() {
    Api.startListen(this, 'recommendations', Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.startListen(this, 'toastProductToken', Api.cache.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED);
  }

  floatingHeader() {
    if (!this.props.location) return false;

    let pathName = this.props.location.pathname;
    return pathName === '/' || pathName === '/about' || pathName === '/login';
  }

  static showInRoute(pathName) {
    let i;
    for (i = 0; i < availableRoutes.length; i++) {
      if (pathName.indexOf(availableRoutes[i]) >= 0) {
        return true;
      }
    }

    return false;
  }

  inMarketplace(currentLocation) {
    if (currentLocation === undefined) {
      currentLocation = this.props.location;
    }

    if (!currentLocation) return false;

    return !!currentLocation.pathname.match('^/retailer/[^/]*(/(product|collection)/[^/]*)?$');
  }

  logoLink() {
    let url = null;

    if (this.props.location) {
      let pathName = this.props.location.pathname;
      let matches = pathName.match(/.*retailer\/([^/]*)/);
      if (matches && matches.length >= 2) {
        url = `/retailer/${matches[1]}`;
      }
    }

    if (!url && this.props.retailer) {
      url = `/retailer/${this.props.retailer.token}`;
    }

    if (!url && this.props.lastSelectedRetailerToken) {
      url = `/retailer/${this.props.lastSelectedRetailerToken}`;
    }

    return (url || '/');
  }

  render() {
    let pathName = this.props.location.pathname;

    if (Header.showInRoute(pathName) === false) return null;

    let classes = classnames({
      'header': true,
      'floating': !this.floatingHeader()
    });

    let logoLink = this.logoLink();

    let searchProducts = null;
    let cart = null;

    let isInvited = this.props.retailer && this.props.retailer.invited;
    let isEmployee = this.state.user && this.state.user.is_employee;
    let marketplaceAvailable = isInvited || isEmployee;
    let showSearchOnThisPage = pathName.indexOf('/retailer') >= 0 || pathName.indexOf('/brand') > 0 || pathName.indexOf('/category') > 0;

    if (marketplaceAvailable) {
      if (showSearchOnThisPage) {
        searchProducts = <TopSearch className="responsive-desktop ib"/>;
      }
      if (pathName.indexOf('/retailer') === 0 || pathName.indexOf('/collection/') > 0 || pathName.indexOf('/user') === 0 || pathName.indexOf('/checkout') === 0) {
        cart = <Cart location={this.props.location} />;
      }
    }

    return (
      <header className={classes}>
        <div className="wrapper">
          <div className="inner-wrapper">
            <nav className="retailer-nav">
              <UserHeader key='header-user-component' user={this.state.user}
                          retailer={this.props.retailer} location={this.props.location}/>
            </nav>
            <nav className="cart-nav">
              {searchProducts}
              {cart}
            </nav>
            <Link className="header-logo logo" to={logoLink}>
              <img src={Logo} role="presentation"/>
            </Link>
          </div>
        </div>
      </header>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/